function setLogoColor() {
	let currentHTMLBackgroundColor = document.documentElement.style
		.getPropertyValue("--background-palette")
		.trim();

	let havaianasLogoSVG = document.body.querySelector("#havaianas-logo>path");
	if (!havaianasLogoSVG) {
		console.error("Logo SVG not found");
		return;
	}

	let r, g, b;

	if (currentHTMLBackgroundColor.startsWith("rgb")) {
		// Handle RGB format
		[r, g, b] = currentHTMLBackgroundColor.match(/\d+/g).map(Number);
	} else if (currentHTMLBackgroundColor.startsWith("#")) {
		// Handle Hex format
		let hex = currentHTMLBackgroundColor.match(
			/#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})/i,
		);
		if (hex) {
			[r, g, b] = hex.slice(1).map((c) => parseInt(c, 16));
		} else {
			console.error("Invalid hex color format");
			return;
		}
	} else {
		console.error("Unsupported color format");
		return;
	}

	// Normalize RGB values
	[r, g, b] = [r, g, b].map((c) => {
		c = c / 255;
		return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
	});

	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
	havaianasLogoSVG.attributes.fill.value = luminance < 0.5 ? "#fff" : "#FB373C";
}
